import {EmptyCart} from 'components/common/EmptyCart'
import {Page} from 'components/system/Page'
import {useOrderCurrencySwitcher} from 'hooks/useOrderCurrencySwitcher'
import {OrderProvider} from 'providers/OrderProvider'
import {Left} from './Left/Left'
import {Right} from './Right/Right'

export const View = () => {
  useOrderCurrencySwitcher()
  const order = OrderProvider.useOrder('optional')

  return (
    <Page className="w-full d:max-w-[1252px] mx-auto px-4 flex flex-col gap-6 d:flex-row justify-between">
      {order ? (
        <>
          <Left />
          <Right />
        </>
      ) : (
        <div className="w-full flex justify-center">
          <EmptyCart />
        </div>
      )}
    </Page>
  )
}
